
import React from 'react';

export const PropertyCardSkeleton: React.FC<{ isCompact?: boolean }> = ({ isCompact = true }) => {
  return (
    <div className={`bg-white rounded-lg shadow-md flex flex-col overflow-hidden animate-pulse ${isCompact ? 'w-60 flex-shrink-0' : ''}`}>
      <div className="aspect-[4/3] bg-gray-300"></div>
      <div className={`${isCompact ? 'p-3' : 'p-4'} flex-grow flex flex-col`}>
        <div className="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
        <div className="h-4 bg-gray-300 rounded w-1/2 mb-4"></div>
        <div className="h-3 bg-gray-300 rounded w-full mb-2"></div>
        <div className="h-3 bg-gray-300 rounded w-5/6"></div>
        <div className="mt-auto pt-3">
          <div className="h-10 bg-gray-300 rounded w-full"></div>
        </div>
      </div>
    </div>
  );
};